import LoginPage from '@/app/login/page'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <LoginPage />
}

export const Route = createFileRoute('/_unauth/login')({
  component: RouteComponent,
})


